export const RETRIEVE_NOTIFICATIONS = "RETRIEVE_NOTIFICATIONS";
export const VIEW_NOTIFICATION = "VIEW_NOTIFICATION";
